
function convertGramsToOunces(num){
  let eq = 'Converting ' + num +" grams to ounces: \n"+
    num +" * 0.035274 = ";
  let rep = num * 0.035274;
  return eq + rep.toFixed(3);
}

function convertGramsToPounds(num){
  let eq = 'Converting ' + num +" grams to pounds: \n"+
    num +" *0.0022046 = ";
  let rep = num * 0.0022046;
  return eq + rep.toFixed(4);
}

function convertGramsToStones(num){
  let eq = 'Converting ' + num +" grams to stones: \n"+
    num +" * 0.00015747 = ";
  let rep = num * 0.00015747 ;
  return eq + rep.toFixed(5);
}

function convertGramsToKilograms(num){
  let eq = 'Converting ' + num +" grams to kilograms: \n"+
   num+" / 1000 = ";
  let rep = num / 1000;
  return eq + rep.toFixed(4);
}


export {
  convertGramsToOunces, convertGramsToPounds,
  convertGramsToStones, convertGramsToKilograms};
